import * as auth from '@/modules/authentication/store';
import * as userTypes from '@/modules/user-type/store';
import * as system from '@/modules/system/store';
import * as functionality from '@/modules/functionality/store';
import * as profile from '@/modules/profile/store';
import * as user from '@/modules/user/store';
import * as authenticatedhome from '@/modules/home/store';
import neoVehicle from '@/modules/neovehicle/store';
import neoPvc from '@/modules/neopvc/store';

import Vue from 'vue';
import Vuex from 'vuex';
import * as root from './root';
import {stateRoot} from './root';

Vue.use(Vuex);

// More info about store: https://vuex.vuejs.org/en/core-concepts.html
// See https://vuejs.org/guide/vuex-store#classic-mode
// structure of the store:
// types: Types that represent the keys of the mutations to commit
// state: The information of our app, we can get or update it.
// getters: Get complex information from state
// action: Sync or async operations that commit mutations
// mutations: Modify the state
interface ModulesStates {
  auth: auth.AuthState;
  userTypes: userTypes.State;
  system: system.State;
  functionality: functionality.State;
  profile: profile.State;
  user: user.State;
  authenticatedhome: authenticatedhome.State;
}

export type RootState = root.State & ModulesStates;

export default new Vuex.Store({
  state: root.stateRoot() as any,
  getters: root.getters,
  mutations: root.mutations,
  actions: root.actions as any,
  modules: {
    [auth.name]: auth,
    [userTypes.name]: userTypes,
    [system.name]: system,
    [functionality.name]: functionality,
    [profile.name]: profile,
    [user.name]: user,
    [authenticatedhome.name]: authenticatedhome,
    neoVehicle,
    neoPvc,
  },
});
